<template>
  <div>
    <el-card>
      <div style="float: right">
        <yearcomponent @change="handler_year" />

        <el-select
          v-model="valueCompanys"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in companys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionProducto"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionProductoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionDepartamento"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionDepartamentoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="valueMoney"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div style="margin-top: 50px">
        <rabbey-table3
          :columns="months"
          :data="dataReStatus"
          :loading="loading"
          :maxheight="1000"
          :paginationApi="{
            currentPage: 1,
            pageSize: 200
          }"
          :pageSizes="[200, 400, 600]"
          default-expand-all
        ></rabbey-table3>
      </div>
      <budgetExecutionDetail
        :executionDetailVisibility="executionDetailVisibility"
        :rowProps="executionRowProps"
        @onCloseExecutionDetail="onCloseExecutionDetail"
        @BudgetAccUpdated="onBudgetAccUpdated"
      />
    </el-card>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import { Months } from "@/views/modules/Status/columns/BudgetExecutionColumns.js";
import yearcomponent from "@/components/Global_System/YearsComponent";
import budgetExecutionDetail from "@/views/modules/Status/budgetExecution/budgetExecutionDetail/budgetExecutionDetail.vue";

export default {
  name: "budgetExecution",
  components: {
    yearcomponent,
    budgetExecutionDetail
  },
  data() {
    return {
      months: Months(this),
      loading: false,
      options: [
        {
          value: "RD",
          label: "RD$"
        },
        {
          value: "US",
          label: "US$"
        }
      ],
      companys: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 9,
          label: "VENTAFIEL TECHNOLOGIES"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 7,
          label: "NUPSHOP"
        },
        {
          value: "Consolidado",
          label: "Consolidado"
        }
      ],
      dataReStatus: [],
      year: 2023,
      valueCompanys: 4,
      valueMoney: "RD",
      DimensionProductoOptions: [],
      DimensionProducto: "*",
      DimensionDepartamentoOptions: [],
      DimensionDepartamento: "*",
      executionDetailVisibility: false,
      executionRowProps: {}
    };
  },
  mounted() {
    this.getDimension();
    this.getDatas();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetDataResultStatus();
    },
    getDimension() {
      this.loading = true;

      this.$http
        .get(`/api/resultsStatus/GetDimesionProducto`)
        .then((resp) => {
          this.loading = false;
          this.DimensionProductoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));

      this.$http
        .get("/api/resultsStatus/GetDimesionDepartamento")
        .then((resp) => {
          this.loading = false;
          this.DimensionDepartamentoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    async GetDataResultStatus() {
      this.loading = true;
      let resultStatus = [];
      var params = {
        option: this.valueCompanys,
        year: this.year,
        divisa: this.valueMoney,
        dim_pro: this.DimensionProducto,
        dim_dep: this.DimensionDepartamento
      };
      await this.$http
        .get(`/api/resultsStatus/GetDataResultStatus`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;
          resultStatus = resp.data;
          // this.dataReStatus = resp.data.filter(
          //   (request) => request.nombre != ""
          // );
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
      return resultStatus;
    },
    async GetBudget() {
      this.loading = true;
      let budgetData = [];

      var params = {
        option: this.valueCompanys,
        year: this.year,
        divisa: this.valueMoney,
        dim_pro: this.DimensionProducto,
        dim_dep: this.DimensionDepartamento
      };
      await this.$http
        .get(`/api/resultsStatus/GetBudget`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;
          budgetData = resp.data;
          //console.log("dataReStatus: ", this.dataReStatus)
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));

      return budgetData;
    },
    async getDatas() {
      let newBugetExecution = [];
      let BudgetData = [];
      let ResultStatus = [];
      ResultStatus = await this.GetDataResultStatus();
      BudgetData = await this.GetBudget();
      //console.log("ResultStatus: ", ResultStatus, "\nBudgetData: ", BudgetData, "\ndataReStatus: ", this.dataReStatus);

      if (ResultStatus.length > 0 && BudgetData.length > 0) {
        newBugetExecution = ResultStatus.filter((rs) => rs.negrita !== "T");
        //console.log("newBugetExecution: ", newBugetExecution)

        newBugetExecution.forEach((nbe) => {
          nbe.eneRS = nbe.ene; // !== null ? nbe.ene : 0
          nbe.febRS = nbe.feb; // !== null ? nbe.feb : 0
          nbe.marRS = nbe.mar; // !== null ? nbe.mar : 0
          nbe.abrRS = nbe.abr; // !== null ? nbe.abr : 0
          nbe.mayRS = nbe.may; // !== null ? nbe.may : 0
          nbe.junRS = nbe.jun; // !== null ? nbe.jun : 0
          nbe.julRS = nbe.jul; // !== null ? nbe.jul : 0
          nbe.agoRS = nbe.ago; // !== null ? nbe.ago : 0
          nbe.sepRS = nbe.sep; // !== null ? nbe.sep : 0
          nbe.octRS = nbe.oct; // !== null ? nbe.oct : 0
          nbe.novRS = nbe.nov; // !== null ? nbe.nov : 0
          nbe.dicRS = nbe.dic; // !== null ? nbe.dic : 0
          nbe.totRS = nbe.tot;

          nbe.eneBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].ene
              : 0;
          nbe.febBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].feb
              : 0;
          nbe.marBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].mar
              : 0;
          nbe.abrBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].abr
              : 0;
          nbe.mayBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].may
              : 0;
          nbe.junBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].jun
              : 0;
          nbe.julBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].jul
              : 0;
          nbe.agoBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].ago
              : 0;
          nbe.sepBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].sep
              : 0;
          nbe.octBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].oct
              : 0;
          nbe.novBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].nov
              : 0;
          nbe.dicBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].dic
              : 0;
          nbe.totBG =
            BudgetData.filter((bg) => nbe.cuenta === bg.cuenta).length > 0
              ? BudgetData.filter((bg) => nbe.cuenta === bg.cuenta)[0].tot
              : 0;

          nbe.ene =
            ((nbe.eneRS !== null ? nbe.eneRS : 0) /
              ((nbe.eneBG !== null ? nbe.eneBG : 0) === 0
                ? 1
                : nbe.eneBG !== null
                ? nbe.eneBG
                : 0)) *
            100;
          nbe.feb =
            ((nbe.febRS !== null ? nbe.febRS : 0) /
              ((nbe.febBG !== null ? nbe.febBG : 0) === 0
                ? 1
                : nbe.febBG !== null
                ? nbe.febBG
                : 0)) *
            100;
          nbe.mar =
            ((nbe.marRS !== null ? nbe.marRS : 0) /
              ((nbe.marBG !== null ? nbe.marBG : 0) === 0
                ? 1
                : nbe.marBG !== null
                ? nbe.marBG
                : 0)) *
            100;
          nbe.abr =
            ((nbe.abrRS !== null ? nbe.abrRS : 0) /
              ((nbe.abrBG !== null ? nbe.abrBG : 0) === 0
                ? 1
                : nbe.abrBG !== null
                ? nbe.abrBG
                : 0)) *
            100;
          nbe.may =
            ((nbe.mayRS !== null ? nbe.mayRS : 0) /
              ((nbe.mayBG !== null ? nbe.mayBG : 0) === 0
                ? 1
                : nbe.mayBG !== null
                ? nbe.mayBG
                : 0)) *
            100;
          nbe.jun =
            ((nbe.junRS !== null ? nbe.junRS : 0) /
              ((nbe.junBG !== null ? nbe.junBG : 0) === 0
                ? 1
                : nbe.junBG !== null
                ? nbe.junBG
                : 0)) *
            100;
          nbe.jul =
            ((nbe.julRS !== null ? nbe.julRS : 0) /
              ((nbe.julBG !== null ? nbe.julBG : 0) === 0
                ? 1
                : nbe.julBG !== null
                ? nbe.julBG
                : 0)) *
            100;
          nbe.ago =
            ((nbe.agoRS !== null ? nbe.agoRS : 0) /
              ((nbe.agoBG !== null ? nbe.agoBG : 0) === 0
                ? 1
                : nbe.agoBG !== null
                ? nbe.agoBG
                : 0)) *
            100;
          nbe.sep =
            ((nbe.sepRS !== null ? nbe.sepRS : 0) /
              ((nbe.sepBG !== null ? nbe.sepBG : 0) === 0
                ? 1
                : nbe.sepBG !== null
                ? nbe.sepBG
                : 0)) *
            100;
          nbe.oct =
            ((nbe.octRS !== null ? nbe.octRS : 0) /
              ((nbe.octBG !== null ? nbe.octBG : 0) === 0
                ? 1
                : nbe.octBG !== null
                ? nbe.octBG
                : 0)) *
            100;
          nbe.nov =
            ((nbe.novRS !== null ? nbe.novRS : 0) /
              ((nbe.novBG !== null ? nbe.novBG : 0) === 0
                ? 1
                : nbe.novBG !== null
                ? nbe.novBG
                : 0)) *
            100;
          nbe.dic =
            ((nbe.dicRS !== null ? nbe.dicRS : 0) /
              ((nbe.dicBG !== null ? nbe.dicBG : 0) === 0
                ? 1
                : nbe.dicBG !== null
                ? nbe.dicBG
                : 0)) *
            100;
          nbe.tot =
            ((nbe.totRS !== null ? nbe.totRS : 0) /
              ((nbe.totBG !== null ? nbe.totBG : 0) === 0
                ? 1
                : nbe.totBG !== null
                ? nbe.totBG
                : 0)) *
            100;
        });
      }
      //console.log("newBugetExecution2: ", newBugetExecution)
      this.dataReStatus = newBugetExecution;
    },
    openExecutionDetail(props) {
      //console.log("props del row: ", props)
      props.year = this.year;
      props.valueCompany = this.valueCompanys;
      this.executionRowProps = props;
      this.executionDetailVisibility = true;
      //alert("se abre el detalle carajo")
    },
    onCloseExecutionDetail() {
      this.executionDetailVisibility = false;
    },
    onBudgetAccUpdated() {
      this.getDatas();
      this.executionDetailVisibility = false;
    }
  },
  watch: {
    DimensionProducto() {
      this.getDatas();
    },
    DimensionDepartamento() {
      this.getDatas();
    },
    valueCompanys() {
      this.getDatas();
    },
    year() {
      this.getDatas();
    },
    valueMoney() {
      this.getDatas();
    }
  }
};
</script>

<style scoped></style>
